import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, Row, Col, Container, CardText, Tooltip } from 'reactstrap';
import { FiltroBar } from "~/components/Filtros/FiltroBar";
import { SubHeader } from "~/components/SubHeader";
import { GoInfo } from "react-icons/go";

import { ConciliacaoContext } from "~/context/ConciliacaoContext";
import { RecebimentosContext } from "~/context/RecebimentosContext";
import { TransactionsContext } from "~/context/TransactionsContext";
import { PedidoContext } from "~/context/PedidoContext";
import { ExtratoContext } from "~/context/ExtratoContext";

import { color } from "~/assets/styles/colors";
import { LoaderMini } from "~/components/Loaders";
import moment from "moment";


import Agenda from "../components/Agenda";
import { StyledCard, StyledTable } from './styles';
import history from '../../../../services/history';
import Totalizador from "../components/Totalizador";
/* eslint-disable */

function DashboardRevenda() {
	const { user } = useSelector((state) => state.auth);

	const { getRecebimentosDashboard, authToken } = useContext(RecebimentosContext);

	const {authGroup, totalGrupos } = useContext(TransactionsContext);

	const { conciliacaoData, getConciliacaoData, getRecebimentosFuturos } = useContext(ConciliacaoContext);
	const { getResumo, dataResumo } = useContext(PedidoContext);

	const { dataSaldo, getSaldo, dataExtrato, getExtrato, setDataExtrato } = useContext(ExtratoContext);

	const [isMobile, setIsMobile] = useState(false);
	const [day, setDay] = useState(0);
	const [month, setMonth] = useState(0);
	const [year, setYear] = useState(0);
	const [tableData, setTableData] = useState({});
	const [params, setParams] = useState({
		dateInit: 'YYYY-MM-DD',
		dateEnd: 'YYYY-MM-DD',
	});
	const [tablePedidos, setTablePedidos] = useState([]);
	const [tableRecebimentos, setTableRecebimentos] = useState([]);
	const [loadingPedidos, setLoadingPedidos] = useState(false);
	const [loadingRecebimentos, setLoadingRecebimentos] = useState(false);

	const [disabledAll, setDisabledAll] = useState(false);
	const [totalizadorValues, setTotalizadorValues] = useState({
		montante: null,
		recebimento: null,
		debito: null,
		compras: null,
	});
	const [tooltipCreditosOpen, setTooltipCreditosOpen] = useState(false);
  	const toggleCreditos = () => setTooltipCreditosOpen(!tooltipCreditosOpen);
	const [recebimentoFuturos, setRecebimentoFuturos] = useState(0);

	const [idTitular, setIdTitular] = useState(
		['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0
			? 'todos'
			: user.dados.lojista_id
	);

	const totalizadorList = [
		{
			color: color.secondary,
			value: user.dados.permissoes.view_labels_pgm_triplo ? (dataResumo.montante  || 0) : (dataSaldo.saldo  || 0),
			title: "MEUS CRÉDITOS",
			subtitle: "",
			textColor: "",
			tooltipText: "",
			idTooltip: "",
			secondValue: "",
			secondText: "",
			borderColor: "",
		},
		{
			color: color.greenLight,
			value: totalizadorValues.recebimento  || 0 ,
			title: "MEUS RECEBIMENTOS",
			subtitle: isTodaySelected() ? "HOJE" : `${day < 10 ? '0' + day : day}/${(month + 1 )< 10 ? '0' + (month + 1 ) : (month + 1 )}/${year < 10 ? '0' + year : year}`,
			textColor: "",
			tooltipText: "",
			idTooltip: "",
			secondValue: recebimentoFuturos,
			secondText: "RECEB. FUTURO",
			borderColor: color.greenDark,
		},
		{
			color: color.yellowLight,
			value: totalizadorValues.debito  || 0 ,
			title: "MINHAS VENDAS",
			subtitle: "HOJE",
			textColor: "",
			tooltipText: "",
			idTooltip: "",
			secondValue: "",
			secondText: "",
			borderColor: color.yellow,
		},
		{
			color: "#fff",
			value: totalizadorValues.compras || 0 ,
			title: "COMPRAS REALIZADAS",
			subtitle: isMonthYearSelected() ? "MÊS ATUAL" : `${(month + 1 )< 10 ? '0' + (month + 1 ) : (month + 1 )}/${year < 10 ? '0' + year : year}`,
			textColor: color.red,
			tooltipText: "",
			idTooltip: "",
			secondValue: "",
			secondText: "",
			borderColor: color.grayMedium,
		},
	]

	async function callConciliacaoData (){
		setDisabledAll(true)
		await getConciliacaoData(params);
	}

	function isMonthYearSelected () {
		const hoje = new Date();
		const mes = (hoje.getMonth() + 1).toString().padStart(2, '0');
		const ano = hoje.getFullYear().toString();

		const dataFormatada = `${ano}-${mes}`;

		const selecionada = `${year < 10 ? '0' + year : year}-${(month + 1 )< 10 ? '0' + (month + 1 ) : (month + 1 )}`

		if(dataFormatada == selecionada){
			return true;
		}

		return false;
	}

	function isTodaySelected (){
		const hoje = new Date();

		const dia = hoje.getDate().toString().padStart(2, '0');
		const mes = (hoje.getMonth() + 1).toString().padStart(2, '0');
		const ano = hoje.getFullYear().toString();

		const dataFormatada = `${ano}-${mes}-${dia}`;

		const selecionada = `${year < 10 ? '0' + year : year}-${(month + 1 )< 10 ? '0' + (month + 1 ) : (month + 1 )}-${day < 10 ? '0' + day : day}`

		if(dataFormatada == selecionada){
			return true;
		}

		return false;
	}

	useEffect(() => {
		const paramsTemp = {
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		};
		setDataExtrato([])

		if(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria'){
			history.push({
			pathname: `/client/transacoes`
			});
		}
		authGroup(paramsTemp, 1, 'todos', idTitular, () => {}).then(() => {})

		getResumo(10, 1, '', '');

		getSaldo(user.dados.documento, '');

		getRecebimentosFuturos().then(res => {
			if(res?.data && res.data > 0){
				setRecebimentoFuturos(res.data)
			}
		});

		const handleResize = () => {
			setIsMobile(window.innerWidth <= 762);
		};



		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		setTotalizadorValues(
			{
				...totalizadorValues,
				debito: totalGrupos['total_vendas'] || 0,
			}
		)
	}, [totalGrupos]);

	useEffect(() => {
		async function fetchData() {
			if (params.dateInit !== 'YYYY-MM-DD' && params.dateInit !== '0-01-01') {
				await callConciliacaoData();
			}
		}
		fetchData();
	}, [params]);

	useEffect(() => {
		if(conciliacaoData){
			const tableObjectDays = {};

			for(let i = 0; i < conciliacaoData.length; i++) {
				const dateObj = new Date(conciliacaoData[i]?.data);
				const dia = dateObj.getUTCDate();
				tableObjectDays[dia] = { blue: conciliacaoData[i]?.creditos, green: conciliacaoData[i]?.recebimentos, red: conciliacaoData[i]?.compras };
			}

			const monthFormated = month + 1;
			let data = `${year < 10 ? '0' + year : year}-${monthFormated < 10 ? '0' + monthFormated : monthFormated}-${day < 10 ? '0' + day : day}`
			const recebimentoSelecionado = conciliacaoData.findIndex((item) => item?.data === data);


			const initialValue = 0;
			const comprasTotal = conciliacaoData.reduce(
				(accumulator, currentValue) => accumulator + (currentValue?.compras || 0),
				initialValue,
			  );

			setTotalizadorValues(
				{
					...totalizadorValues,
					recebimento: conciliacaoData[recebimentoSelecionado]?.recebimentos ? conciliacaoData[recebimentoSelecionado]?.recebimentos : 0.00,
					montante: dataResumo.montante,
					compras: comprasTotal || 0
				})

			setTableData(tableObjectDays)
			setDisabledAll(false)
		}else{
			setDisabledAll(false)
			setTableData({});
		}
	}, [conciliacaoData]);

	useEffect(() => {
		setLoadingPedidos(true);
		setLoadingRecebimentos(true);
		const monthFormated = month + 1;
		let data = `${year < 10 ? '0' + year : year}-${monthFormated < 10 ? '0' + monthFormated : monthFormated}-${day < 10 ? '0' + day : day}`

		const recebimentoSelecionado = conciliacaoData.findIndex((item) => item?.data === data);

		if(conciliacaoData[recebimentoSelecionado]){
			setTotalizadorValues({...totalizadorValues, recebimento: conciliacaoData[recebimentoSelecionado].recebimentos })
		}else{
			setTotalizadorValues({...totalizadorValues, recebimento: 0.00 })
		}

		if(data !== "00-01-00"){
			authToken().then((tokenResponse) => {
				getRecebimentosDashboard(tokenResponse || '', { dateInit: data, dateEnd: data }, 1, '', '').then((res) => {
					setLoadingRecebimentos(false);
					if(res?.recebimentos){
						setTableRecebimentos(res.recebimentos)
					} else {
						setTableRecebimentos([])
					}
				}).catch((err)=> {
					setLoadingRecebimentos(false);
				});
			})

			getExtrato(user.dados.documento, 1, `&data_lancamento=${data}%7C${data}`, '', '', '', '', 1000).then(() => {
				setLoadingPedidos(false)
			}).catch((err)=> {
				setLoadingPedidos(false)
			});
		}

	}, [month, year, day]);

	useEffect(() => {
		let data = `${day < 10 ? '0' + day : day}/${(month + 1 ) < 10 ? '0' + (month + 1 ) : (month + 1 )}/${year < 10 ? '0' + year : year}`
		const justSelectedDate = dataExtrato?.every(item => item?.data_lancamento.startsWith(data));
		if (justSelectedDate) {
			setTablePedidos(dataExtrato)
		} else {
			setTablePedidos([])
		}
	}, [dataExtrato]);


	return (
		<Container fluid>
			<SubHeader />
			{user.dados.tipo_cliente === 'grupo' && <FiltroBar />}
			<Row>
				<Col style={{padding: 0, margin: 0}}>
					<Totalizador
						hojeSelecionado={isTodaySelected}
						isMobile={isMobile}
						totalizadorList={totalizadorList}
						maxQuantidade={3}
						/>
				</Col>
				<Col
					lg="12"
					className={`${window.innerWidth <= 1000 ? "d-flex align-self-stretch flex-column" : "d-flex align-self-stretch" }`}>

					<Col
						lg={`${window.innerWidth <= 1000 ? '12' : '6' }`}
						className={`${window.innerWidth <= 1000 ? "d-flex flex-column align-self-stretch" : "d-flex align-self-stretch" }`}>
						<Card
							className="w-100 h-100"
							style={{ borderRadius: '10px 10px 0 0', height:  isMobile ? '400px' : ''  }}>
							<Agenda
								isMobile={isMobile}
								typeData="money"
								tableData={tableData}
								setTableData={setTableData}
								dayNumber={day}
								setDay={setDay}
								month={month}
								setYear={setYear}
								year={year}
								setMonth={setMonth}
								params={params}
								setParams={setParams}
								disabledAll={disabledAll}
								setDisabledAll={setDisabledAll}
								/>
						</Card>
					</Col>
					<Col
						lg={`${window.innerWidth <= 1000 ? '12' : '6' }`}
						className={`${window.innerWidth <= 1000 ? "d-flex flex-column" : "d-flex flex-column" }`}>
							<StyledCard
								className="w-100"
								>
									<CardText style={{ margin:4}}>
										<b>MEUS CRÉDITOS</b>
										<GoInfo
											style={{ marginLeft:5, marginBottom:3, cursor: 'pointer' }}
											onClick={toggleCreditos}
											id="Tooltip-creditos"
										/>
										<Tooltip
											placement="top"
											isOpen={tooltipCreditosOpen}
											target="Tooltip-creditos"
											toggle={toggleCreditos}
										>
											...
										</Tooltip>
									</CardText>
									{loadingPedidos ? (
										<LoaderMini />
									) : (
										<StyledTable>
											<thead className="notranslate">
												<tr style={{backgroundColor: color.secondary}}>
													<th style={{textAlign: "center", width: '20%'}}>DATA</th>
													<th style={{textAlign: "center"}}>ID DOCUMENTO</th>
													<th style={{textAlign: "center", padding:"5px"}}>CRÉDITO</th>
													<th style={{textAlign: "center", padding:"5px"}}>VALOR</th>
												</tr>
											</thead>
											<tbody style={{border: `1px solid ${color.secondary}`}}>
												{tablePedidos.length > 0
													?
													tablePedidos.map((item, index) => (
														<tr key={index}>
															<td style={{textAlign: "center"}}>{item.data_lancamento ?  item.data_lancamento.split(" ")[0] : ''}</td>
															<td style={{textAlign: "center"}}>{item?.documento ? item.documento : ''}</td>
															<td style={{textAlign: "center"}}>{item.credito ? `${item.credito.toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}`: ''}</td>
															<td style={{textAlign: "center", color: item.valores >= 0 ? color.green : color.redMedium}}>{item.valores ? `${item.valores.toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}`: ''}</td>
														</tr>
													))
													:
													<tr style={{textAlign: "center"}}>
														<td colSpan={5}>NENHUM ITEM LOCALIZADO</td>
													</tr>
												}
											</tbody>
										</StyledTable>
									)}
							</StyledCard>

							<StyledCard
								style={{marginBottom: '100px'}}
								className="w-100"
									>
									<CardText style={{  margin: "4px"}}>
										<b>MEUS RECEBIMENTOS</b>
									</CardText>

									{loadingRecebimentos ? (
										<LoaderMini />
									) : (
										<StyledTable>
											<thead>
												<tr style={{backgroundColor: color.primary}}>
													<th style={{textAlign: "center", width: "15%"}} className="notranslate">DATA RECEB.</th>
													<th style={{textAlign: "center"}}>VALOR</th>
													<th style={{textAlign: "center"}}>NSU</th>
													<th style={{textAlign: "center"}}>AUTORIZAÇÃO</th>
												</tr>
											</thead>
											<tbody style={{border: `1px solid ${color.primary}`}}>
												{tableRecebimentos.length > 0
													?
													tableRecebimentos.map((item, index) => (
														<tr key={index} style={{border: `1px solid ${color.primary} !important`}}>
															<td style={{textAlign: "center"}}>{item.data_agendado ? item.data_agendado: ''}</td>
															<td style={{textAlign: "center", color: item.valor_liquido > 0 ? 'black' : color.red }}>{item.valor_liquido ?`${item.valor_liquido.toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}` : ''}</td>
															<td style={{textAlign: "center"}}>{item.nsu ? item.nsu : ''}</td>
															<td style={{textAlign: "center"}}>{item?.autorizacao ? item.autorizacao : ''}</td>

														</tr>
													))
													:
													<tr style={{textAlign: "center"}}>
														<td colSpan={4}>NENHUM ITEM LOCALIZADO</td>
													</tr>
												}
											</tbody>
										</StyledTable>
									)}
							</StyledCard>
					</Col>


				</Col>


			</Row>
		</Container>
	);
}

export default DashboardRevenda;
